import axios from 'axios';
import CryptoJS from 'crypto-js';
import { postApi } from '../../lib/fetcher';
import { showAlert } from '../../lib/helpers';

const bulk = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      totalPage: 0,
      loading: false,
      errors: [],
      flashError: false,
      flashErrorMessage: '',
      requestData: null,
      updatedBulk: false,

      countData: 0,
      onUpload: false,
    };
  },
  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },
    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },
    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },
    clearErrors(state) {
      state.errors = [];
    },
    setErrors(state, payload) {
      state.errors = payload;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCancelation(state, payload) {
      state.requestData = payload;
    },
    setUpdatedBulk(state, payload) {
      state.updatedBulk = payload;
    },

    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },
    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sortbyData = `${sortBy[0] ? sortBy[0] : 'created_at'} ${sort}`;

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sortBy: sortbyData,
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/reserved_mid/reserved-mid/list-history-reserved-mid`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async downloadFile(ctx, { date, id, type }) {
      const val = {
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      };
      const newVal = id ? { id } : {};

      const newConfig = { ...val, ...newVal };

      const data = JSON.stringify(newConfig);

      const urlControll =
        type === 'template'
          ? 'reserved_mid/reserved-mid/download-template-file'
          : 'reserved_mid/reserved-mid/download-file';

      const urlApi = `/index.php?r=api/v1/${urlControll}`;
      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        return responseData.data;
      }

      return false;
    },

    async bulkUpload(ctx, { file, date }) {
      ctx.commit('setOnUpload', true);
      const data = new FormData();

      data.append('file', file);
      data.append(
        'version',
        btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        )
      );
      const urlApi = `/index.php?r=api/v1/reserved_mid/reserved-mid/upload-mid`;

      const responseData = await postApi(ctx, urlApi, data);
      let returnVal = false;

      if (responseData?.code == '200') {
        ctx.commit('setUpdatedBulk', true);
        returnVal = true;
      } else if (responseData?.code == '302') {
        showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
      }
      ctx.commit('setOnUpload', false);

      return returnVal;
    },
  },
};

export default bulk;
